import React, { useRef, useState, useEffect } from "react";
import "../../../StyleSheet/MainComponent/Role/RoleCreate.scss";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { SettheExcelSheeetUpaloads } from "../../../Redux/Slice";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import dayjs from "dayjs";


const ExcelSheetUpload = (props) => {
  const form_data = new FormData();
  const ref = useRef();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const { setShow, show, branchId, page ,filters} = props;
  console.log(page, "page");
  const currentDate = dayjs();
const currentYear = currentDate.year();
const currentMonth = currentDate.month() + 1; // 1–12



useEffect(() => {
  const handler = (e) => {
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
      console.log("GLOBAL BLOCK", e.key);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  window.addEventListener("keydown", handler, true); // capture phase

  return () => window.removeEventListener("keydown", handler, true);
}, []);


  const handleClose = () => {
  

    Swal.fire({
      title: `Do you want to exit?`,
      // text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        
          setShow(false);

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });


  };

  const Swal = require("sweetalert2");
  // const initialState = {
  // file: "",
  // };
  // const [data, setDatas] = useState(initialState);
  // const [FileError, setFileErrors] = useState("");
  // const dispatch = useDispatch();

  // const HandleChanges = (e) => {
  // console.log(e.target.files[0], "test the file");

  // const a = [];
  // a.push(e.target.files[0]);
  // console.log(a);
  // a.map((file) => {
  // form_data.append("file", file);
  // });
  // };

  // const handleClose = () => {
  // setShow(false);
  // };

  // const HandleSubmits = () => {
  // console.log(data, "datas");
  // var a = 0;
  // for (var pair of form_data.entries()) {
  // console.log(pair[0] + ", " + pair[1]);
  // }

  // console.log(data, "datas");
  // form_data.append("client_id", branchId);
  // const payload = {
  // data: form_data,
  // };
  //---Have---to----Dispatch----the-----excel---post---api
  // dispatch(SettheExcelSheeetUpaloads({ form_data }));
  // };
  const Datess = {
    year: "",
    month: "",
  };
  const [Dates, setDates] = useState(Datess);

  const initialState = {
    year: "",
    month: "",
  };
  const [data, setDatassheet] = useState(initialState);
  const [FileError, setFileErrors] = useState("");
  const [Files, setFiles] = useState();
  const [monthError, setmonthError] = useState("");
  const [yearError, setYearError] = useState("");
  const HandleChanges = (e) => {
    console.log(e.target.files[0], "test the file");
    // setDatas({
    //   ...data,
    //   file: e.target.files[0],
    // });
    const a = [];
    a.push(e.target.files[0]);
    console.log(a);
    a.map((file) => {
      setFiles(file);
    });
  };
  const handleDates = (e) => {
    console.log(e, "ydoiasuoiduasd ", e );
    if(e != null){
    const year = new Date(e.$d);
    setDates({
      ...Dates,
      year: e,
    });
    // console.log(year.getFullYear(), "ojkmn");
    //form_data.append("data",year.getFullYear())
    setDatassheet({
      ...data,
      year: String(year.getFullYear()),
    });
  } else {
        setDates({
      ...Dates,
      year: "",
    });
     setDatassheet({
      ...data,
      year: "",
    });
  }

    //form_data.append("data",data.year)
  };
  console.log(data ,"date from the data");
  
  const handleMonths = (e) => {
    if(e != null){ 
    const month = new Date(e.$d);
    // console.log(String(month.getMonth() + 1), "dbn");
    setDatassheet({
      ...data,
      month: String(month.getMonth() + 1),
    });
    setDates({
      ...Dates,
      month: e,
    });
  } else {
     setDates({
      ...Dates,
      month: "",
    });
      setDatassheet({
      ...data,
      month: "",
    });
  }
  };
  useEffect(() => {
    if (
      state.excelsheets.ExcelSheets != [] &&
      state.excelsheets.ExcelSheets != undefined &&
      state.excelsheets.ExcelSheets != ""
    ) {
      setDates({
        ...Dates,
        month: "",
        year: "",
      });
      if (ref.current) {
        ref.current.value = "";
        ref.current.type = "text";
        ref.current.type = "file";
      }
    }
  }, [state.excelsheets.ExcelSheets]);

  const HandleSubmits = () => {
 
    var a = 0;
    for (var pair of form_data.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
    if (!data.month || data.month == "") {
      a = 1;
      setmonthError("*Month is required");
    }
    if (!data.year || data.year == "") {
      a = 1;
      setYearError("*Year is required");
    }
    if (ref.current.value == "") {
      a = 1;
      setFileErrors("*File is required");
    }
    if(a == 0){
         form_data.append("client_id", state.ClientBranchIDs.clientBranchEditView);
    form_data.append("data", JSON.stringify(data));
    form_data.append("file", Files);
    console.log(data, "datas");
    console.log("dsxz", Files);
    }

    console.log(data, "datas");
    const payload = {
      data: form_data,
      branchId: branchId,
      pages: page,
      month:filters?.month,
      year:filters?.year
    };
    if (a == 0) {
      Swal.fire({
        title: `Do you want to upload shift sheet ?`,
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          //---Have---to----Dispatch----the-----excel---post---api
          dispatch(SettheExcelSheeetUpaloads(payload));
          setShow(false);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };


  return (
    <>
      <div>
        <div className="RoleCreatePopup">
          <div className="BeforePopUp">
            <div className="RolePopups" style={{ width: "40%" }}>
              <div className="asds">
                        <div className="ModalHeader" style={{background:"#234492", color:'#fff', borderRadius:"5px 5px 0px 0px "}}>
                  <span style={{color:'#fff'}} className="UserCreate"> Shift excel upload </span>
                  <div className="CloseIcon" onClick={(e) => handleClose(e)}>
                    <CloseOutlinedIcon />
                  </div>
                </div>
              </div>
 
              <div class="col-12 field-div" style={{padding:"24px 12px 0px"}}>
                <label
                  for="validationCustom01"
                  class="form-label"
                  style={{ fontSize: "15px" }}
                >
                  Upload your File
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="file"
                  autoComplete="off"
                  required
                  onChange={(e) => {
                    HandleChanges(e);
                    setFileErrors("");
                  }}
                  ref={ref}
                  accept=".xlsx"
                  //accept=".xml"
                  style={{
                    padding: "10px",
                  }}
                  name="file"
                ></input>
                <p style={{ color: "red", marginTop: "5px",
                                        fontSize:"13px"

                 }}>{FileError}</p>
              </div>
             <p
  style={{
    color: "#234492",
    background: "#eaedfd",
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "500",
    margin: "15px 10px 15px"
  }}
>
  <span style={{color:"#000",marginRight:"3px" , fontWeight:"600"}}>{`Note : `}</span>
   {`Shift uploads accept only future dates.`}
</p>
              <div className="row" style={{ padding: "0px 15px" }}>
                <div
                  className="col-6 mt-1 "
                  style={{
                    marginTop: "10px",
                  }}
                >
                  
                  <label
                    for="validationCustom01"
                    class="form-label m-0"
                    style={{
                      fontSize: "15px",
                    }}
                  >
                    Year
                    <span style={{ color: "red" }}>*</span>
                  </label>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={["DatePicker", "DatePicker"]}>
    <DatePicker
      openTo="year"
      views={["year"]}
      value={Dates.year}
      onChange={(newValue) => {
        
        if (newValue && newValue.isValid()) {
          const year = newValue.year();
          handleDates(newValue);
          setYearError("");
        } else {
          handleDates("");
        }
      }}
            minDate={dayjs(`${currentYear}-01-01`)} 

      maxDate={dayjs(`${currentYear}-12-31`)}
slotProps={{
  textField: {
    onKeyDown: (e) => {
      const blocked = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
      if (blocked.includes(e.key)) {
        console.log("BLOCKED DOWN", e.key);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    onKeyUp: (e) => {
      const blocked = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
      if (blocked.includes(e.key)) {
        console.log("BLOCKED UP", e.key);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    inputProps: {
      readOnly: true,
      onWheel: (e) => e.preventDefault(),  
    }
  }
}}



disableFuture
  disablePast
  closeOnSelect
  shouldDisableYear={(year) => year.year() !== currentYear}


disableKeyboardControl={true}

    />
  </DemoContainer>
</LocalizationProvider>

                  <p
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontSize:"13px"
                    }}
                  >
                    {yearError}
                  </p>
                </div>

                <div
                  className="col-6 mt-1"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <label
                    for="validationCustom01"
                    class="form-label m-0"
                    style={{
                      fontSize: "15px",
                    }}
                  >
                    Month
                    <span style={{ color: "red" }}>*</span>
                  </label>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={["DatePicker", "DatePicker"]}>
    <DatePicker


      openTo="month"
      views={["month"]}
      value={Dates.month}
            onChange={(newValue) => {
        if (newValue && newValue.isValid()) {
          const month = (newValue.month() + 1).toString(); 
          handleMonths(newValue);
          setmonthError("");
        } else {
          handleMonths("");
        }
      }}
            minDate={dayjs(`${currentYear}-${currentMonth}-01`)} 

      maxDate={dayjs(`${currentYear}-12-31`)}
slotProps={{
  textField: {
    inputProps: {
      readOnly: true,
      onKeyDown: (e) => {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  }
}}



  disableKeyboardControl={true}

disableFuture
  disablePast
  closeOnSelect
  shouldDisableYear={(year) => year.year() !== currentYear}

    />
  </DemoContainer>
</LocalizationProvider>
                  <p
                    style={{
                      color: "red",
                      marginTop: "5px",
                                            fontSize:"13px"

                    }}
                  >
                    {monthError}
                  </p>
                </div>
              </div>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={HandleSubmits}
                >
                  Submit
                </button>

                <button class="btn CancelBtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExcelSheetUpload;
